import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { ActivityTypes } from "../../config/config";
export const fetchAllActivityCode = createAsyncThunk(
  'activityCode/fetchAllActivityCode',
  async (_arg: any, { rejectWithValue }) => {

    //`Utilities/ActivityTypes`
    try {
      const response = await apiClient.get(ActivityTypes, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'
        },
      });
      // console.log("All-activityCode", response.data);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const activityCodeSlice = createSlice({
  name: 'activityCode',
  initialState: {
    activityCode: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllActivityCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllActivityCode.fulfilled, (state, action) => {
        state.loading = false;
        state.activityCode = action.payload;

         state.activityCode.sort((a, b) =>
                 a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      })
      .addCase(fetchAllActivityCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default activityCodeSlice.reducer;
